import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/company-owners-controller';
import { MaterialReactTable } from 'material-react-table';

export const CompanyOwnersRoute = () => {
    const { tableSettings } = useController();

    return (
        <OWContainer>
            <MaterialReactTable table={tableSettings} />
        </OWContainer>
    );
};
